module.exports = __webpack_public_path__ + "img/yanglao_image.b3cf2002.png";